/**
 * @fileoverview PhoneValidationRenderer.module.css
 * Styles for the PhoneValidationRenderer component that displays a phone input field.
 *
 * @example
 * // Basic usage with the PhoneValidationRenderer component
 * import css from './PhoneValidationRenderer.module.css'
 *
 * <div className={css.container}>
 *   <input className={css.input} type="tel" placeholder="Phone Number" />
 *   <div className={css.flag}>+1</div>
 * </div>
 */

.container {
    width: 224px;
    display: flex;
}

.input {
    font-family: Inter, 'system-ui';
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    text-align: center;
    align-items: center;
    width: 3.5rem;
    height: 3.5rem;
    background: #ffffff;
    border: 1px solid var(--neutural400);
    border-right: none;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 0;

    font-size: 18px;
    font-weight: 400;
    color: var(--gray900);
}

.input:focus,
.input:active {
    border: 1px solid var(--neutural400);
    z-index: 10;
}

.input:first-of-type {
    border-radius: 0.75rem 0 0 0.75rem;
}

.input:last-of-type {
    border-radius: 0 0.75rem 0.75rem 0;
    border: 1px solid var(--neutural400);
}

.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.input::placeholder {
    color: var(--neutural500);
    font-weight: 300;
}

.error {
    outline: 6px solid var(--red300);
    border: 1px solid var(--neutural900);
    border-radius: 0.75rem;
}

.error .input {
    border: 0px;
    border-right: 1px solid var(--neutural900);
}

.error .input:last-of-type {
    border: 0px;
}

.errorMessage {
    color: var(--red700);
}
